<template>
    <div>
        <!-- <v-expand-transition> -->
        <v-card
            v-if="openCheck()"
            :ref="randomId"
            flat
            light
            :class="`ma-0 mb-1 primary--border ${radiusClass} ${
                type === 'lay'
                    ? 'lay-border'
                    : type === 'back'
                    ? 'back-border'
                    : ''
            }`"
        >
            <placebet-loader
                v-if="$store.state.placeBet && placeBetLoading"
                absolute
            ></placebet-loader>
            <v-form ref="betForm" v-model="valid" @submit.prevent="placeBet">
                <v-container class="pb-0">
                    <v-list-item-title class="caption">
                        <!-- <div>
                  {{
                    bettingType === 'premiumsports'
                      ? bettingMarket.name
                      : bettingMarket.eventName
                  }}
                </div> -->
                        <!-- <div>
                  {{
                    bettingType === 'lineLadder'
                      ? bettingMarket.name
                      : bettingRunner.name
                  }}
                </div> -->

                        <!-- Multi bets -->
                        <div v-if="bettingType === 'lineLadder'">
                            {{ bettingMarket.name }}
                        </div>
                        <div
                            v-else-if="bettingMarket.name === 'Multi Bet'"
                            class="d-flex align-items-center flex-wrap"
                        >
                            <div
                                class="black--text text-capitalize whitespace-normal d-inline"
                            >
                                {{
                                    bettingMarket.multiBetDisplayNameArray.join(
                                        ", "
                                    )
                                }}
                            </div>
                        </div>
                        <div v-else>
                            {{ bettingRunner.name }}
                        </div>
                        <!-- Multi bets -->

                        <!-- <div v-if="bettingType !== 'lineLadder'">
                  {{ bettingRunner.name }}
                </div>
                <div v-if="bettingType === 'lineLadder'">
                  {{ bettingMarket.name }}
                </div> -->
                    </v-list-item-title>
                    <v-row justify="center" class="my-0 stake-row">
                        <v-col cols="6" class="pb-0">
                            <!-- default text feild -->
                            <v-text-field
                                ref="runsOddsRef"
                                v-show="
                                    bettingType !== 'fancy' &&
                                    bettingType !== 'bookmaker' &&
                                    bettingType !== 'threeEt' &&
                                    bettingType !== 'multiHorse' &&
                                    bettingType !== 'artemisBookmaker' &&
                                    bettingType !== 'artemisFancy' &&
                                    bettingMarket.name.toLowerCase() !==
                                        'tied match'
                                "
                                v-model="odds"
                                :prepend-inner-icon="
                                    bettingType === 'premiumsports'
                                        ? 'mdi-minus-disable'
                                        : 'mdi-minus'
                                "
                                :append-icon="
                                    bettingType === 'premiumsports'
                                        ? 'mdi-plus-disable'
                                        : 'mdi-plus'
                                "
                                :label="
                                    bettingType === 'lineLadder'
                                        ? 'Runs'
                                        : 'Odds'
                                "
                                persistent-hint
                                hide-details="auto"
                                outlined
                                dense
                                :rules="oddsRules"
                                class="caption"
                                inputmode="numeric"
                                @blur="oddsBlur"
                                @keypress="onlyNumber"
                                @keydown.40="oddsStepper('down')"
                                @keydown.38="oddsStepper('up')"
                                @click:prepend-inner="oddsStepper('down')"
                                @click:append="oddsStepper('up')"
                            ></v-text-field>
                            <!-- only for fancy -->
                            <v-text-field
                                v-show="
                                    bettingType === 'fancy' ||
                                    bettingType === 'artemisFancy'
                                "
                                v-model="runs"
                                label="Runs"
                                persistent-hint
                                hide-details="auto"
                                outlined
                                dense
                                class="caption"
                                readonly
                            ></v-text-field>
                            <!-- only for bookmaker -->
                            <v-text-field
                                v-show="
                                    [
                                        'bookmaker',
                                        'multiHorse',
                                        'artemisBookmaker'
                                    ].includes(bettingType) ||
                                    bettingMarket.name.toLowerCase() ===
                                        'tied match'
                                "
                                v-model="odds"
                                label="Odds"
                                persistent-hint
                                hide-details="auto"
                                outlined
                                dense
                                class="caption"
                                readonly
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="pb-0">
                            <v-text-field
                                ref="stake"
                                v-model="stake"
                                label="Stake *"
                                :placeholder="`${placeholderMinMax}`"
                                persistent-hint
                                hide-details="auto"
                                outlined
                                dense
                                :rules="stakeRules"
                                class="caption"
                                inputmode="numeric"
                                @keydown.40="stakesAdd(-1)"
                                @keydown.38="stakesAdd(1)"
                                @keypress="onlyNumber"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-row
                        v-if="userConfig"
                        align="center"
                        justify="center"
                        no-gutters
                        :class="{
                            'mt-2':
                                !!stake !== !$refs?.stake?.valid &&
                                !!odds !== !$refs?.runsOddsRef?.valid
                        }"
                    >
                        <v-col
                            v-for="(
                                mobileStake, index
                            ) in userConfig.mobileStake"
                            :key="index"
                            cols="4"
                            class="px-1 my-1 stake-size"
                        >
                            <v-btn
                                color="primary"
                                block
                                depressed
                                small
                                rounded
                                @click="stakesAdd(mobileStake)"
                                >+{{ mobileStake | currencyFormat(0) }}</v-btn
                            >
                        </v-col>
                    </v-row>
                    <v-row
                        class="mt-2 mb-0"
                        align="center"
                        justify="center"
                        no-gutters
                    >
                        <v-col cols="6" class="px-1">
                            <v-btn
                                class="cancel-betslip"
                                block
                                outlined
                                rounded
                                :disabled="loading"
                                @click="cancelBtn()"
                                >Cancel</v-btn
                            >
                        </v-col>

                        <v-col cols="6">
                            <v-btn
                                class="multiline-btn place-bet-btn text-white"
                                :loading="placeBetLoading"
                                block
                                depressed
                                rounded
                                color="green"
                                type="submit"
                                :disabled="!valid"
                            >
                                <span class="d-block text-center"
                                    >Place Bet</span
                                >

                                <template v-if="valid && winning > 0">
                                    <span
                                        class="d-block text-center"
                                        style="
                                            line-height: 100%;
                                            font-size: 10px !important;
                                        "
                                    >
                                        <span
                                            >{{
                                                type === "lay"
                                                    ? "Liability"
                                                    : "Profit"
                                            }}:</span
                                        >
                                        <span
                                            v-if="bettingType === 'bookmaker'"
                                        >
                                            {{ winning | currencyFormat(2) }}
                                        </span>
                                        <span v-else>
                                            {{ winning | currencyFormat(0) }}
                                        </span>
                                    </span>

                                    <div
                                        v-if="shouldShowBetDelay"
                                        class="sec-text"
                                    >
                                        <span>{{ calculatedBetDelay }}s</span>
                                    </div>

                                    <div
                                        v-if="shouldShowBookmakerFancyDelay"
                                        class="sec-text"
                                    >
                                        <span
                                            >{{
                                                betDelayforBookmakerFancy
                                            }}s</span
                                        >
                                    </div>
                                </template>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <confirm-bet></confirm-bet>
                    <v-row class="mb-2" no-gutters>
                        <v-col class="text-right">
                            <v-btn
                                x-small
                                to="/settings"
                                color="primary"
                                text
                                class="caption"
                                >Edit Stakes</v-btn
                            >
                        </v-col>
                    </v-row>
                    <v-skeleton-loader
                        v-if="minMaxMarketLoading"
                        type="list-item"
                    ></v-skeleton-loader>
                    <div
                        v-if="!minMaxMarketLoading"
                        class="caption primary--text mt-2"
                    >
                        <div class="row minmax-market-wrapper">
                            <template v-for="label in displayValues">
                                <div
                                    v-if="label.condition"
                                    :key="label.text"
                                    class="col-12 pa-0"
                                >
                                    {{ label.text }}:
                                    <span class="font-weight-bold">{{
                                        label.value
                                    }}</span>
                                </div>
                            </template>
                        </div>
                    </div>

                    <confirm-betdialogue
                        :new-this="this"
                        @confirm="placeBet"
                    ></confirm-betdialogue>
                </v-container>
            </v-form>
        </v-card>
        <!-- </v-expand-transition> -->
    </div>
</template>
<script>
import { mapState } from "vuex"
// import isEmpty from 'lodash/isEmpty'
import multiply from "lodash/multiply"
import subtract from "lodash/subtract"
import round from "lodash/round"
import cloneDeep from "lodash/cloneDeep"
import map from "lodash/map"
import upperFirst from "lodash/upperFirst"
import compact from "lodash/compact"
import min from "lodash/min"
import ceil from "lodash/ceil"
import ConfirmBet from "@/components/ConfirmBet"
import PlacebetLoader from "@/components/PlacebetLoader"
import ConfirmBetdialogue from "@/components/ConfirmBetdialogue"
import { multibetlayBookHorseId } from "~/constant"

export default {
    components: { ConfirmBet, ConfirmBetdialogue, PlacebetLoader },
    props: {
        checkId: {
            type: [String, Number, Array],
            default: "",
            required: false
        },
        radiusClass: {
            type: String,
            default: "all-radius",
            required: false
        }
    },
    data() {
        return {
            randomId: Date.now(),
            gameMode: "SportsBook",
            betDelayforBookmakerFancy: 0,
            lineSession: 2,
            valid: true,
            winning: 0,
            stake: "",
            odds: 0,
            position: 0,
            type: "",
            minBet: 1,
            maxBetShow: true,
            maxMarketAmountShow: true,
            placeBetLoading: false,
            maxMarketAmount: 0,
            minBetAmt: 1,
            endPoint: 1,
            maxBetAmt: 1000000000000000,
            placeholderMinMax: "",
            maxLimitsType: "",
            oddsRules: [
                (v) => !!v || "Odds is required",
                (v) => parseFloat(v) >= 1.01 || "Min. 1.01"
            ],
            stakeRules: [
                (v) => !!v || "",
                (v) => parseInt(v) >= this.minBet || "Min. " + this.minBet,
                (v) => parseInt(v) <= this.maxBetAmt || "Max. " + this.maxBetAmt
            ]
        }
    },
    computed: {
        ...mapState({
            bettingMarket: (state) => state.placeBet.market,
            isCashOut: (state) => state.placeBet.isCashOut,
            bettingRunner: (state) => state.placeBet.runner,
            bettingAllRunners: (state) => state.placeBet.allRunners,
            bettingType: (state) => state.placeBet.bettingType,
            runs: (state) => state.placeBet.runs,
            matchIds: (state) => state.placeBet.matchIds,
            userConfig: (state) => state.settings.userConfig,
            cloneOdds: (state) => state.placeBet.odds,
            cloneType: (state) => state.placeBet.type,
            stakeValue: (state) => state.placeBet.stake,
            loading: (state) => state.placeBet.loading,
            minMaxMarketLoading: (state) =>
                state.matchInside.minMaxMarketLoading,
            configLimits: (state) => state.matchInside.configlimits,
            minMaxMarket: (state) => state.matchInside.minMaxMarket,
            minMaxMarketPremium: (state) =>
                state.matchInside.minMaxMarketPremium,
            minMaxMarketBookmaker: (state) =>
                state.matchInside.minMaxMarketBookmaker,
            userBalanceData: (state) => state.userBalance.userBalanceData,
            vpnData: (state) => state.user.vpnData,
            betValue: (state) => state.betLoading.value,
            closedByTimer: (state) => state.placeBet.closedByTimer
        }),
        displayValues() {
            return {
                minBet: {
                    condition: true,
                    text: "Min Bet",
                    value: this.minBet
                },
                maxBet: {
                    condition: this.maxBetShow,
                    text: "Max Bet",
                    value: this.maxBetAmt
                },
                maxWinning: {
                    condition:
                        this.maxMarketAmountShow && this.maxMarketAmount !== 0,
                    text: "Max Winning",
                    value: this.maxMarketAmount
                },
                maxWinningPerBet: {
                    condition:
                        this.bettingType &&
                        ["artemisBookmaker", "artemisFancy"].includes(
                            this.bettingType
                        ) &&
                        this.minMaxMarketBookmaker?.maxWinningPerBet,
                    text: "Max Winning Per Bet",
                    value: this.minMaxMarketBookmaker?.maxWinningPerBet
                }
            }
        },
        shouldShowBetDelay() {
            return (
                this.valid &&
                this.winning > 0 &&
                this.bettingMarket &&
                this.bettingMarket.betDelay > 0 &&
                this.bettingType !== "premiumsports"
            )
        },
        calculatedBetDelay() {
            if (this.bettingType === "fancy") {
                return this.bettingRunner?.betDelay === 0
                    ? 1
                    : this.bettingRunner.betDelay
            }
            return this.bettingMarket?.betDelay === 0
                ? 1
                : this.bettingMarket?.betDelay
        },
        shouldShowBookmakerFancyDelay() {
            return (
                this.betDelayforBookmakerFancy &&
                this.valid &&
                this.winning > 0 &&
                ["artemisBookmaker", "artemisFancy"].includes(this.bettingType)
            )
        }
    },
    watch: {
        cloneOdds() {
            this.initiatePopover()
        },
        // cloneType() {
        //   this.initiatePopover()
        // },
        odds() {
            this.calculateWinnings()
        },
        stake() {
            this.calculateWinnings()
        },
        configLimits() {
            this.setFancyLimit(100000000000000000000)
        },
        async vpnData() {
            try {
                const vpnInfo = this.vpnData?.data?.data
                if (vpnInfo?.isVpn) {
                    sessionStorage.setItem("isVpnDetected", vpnInfo.msg)
                    await this.$store.dispatch("user/logout")
                }
            } catch (error) {
                console.error("Error checking VPN data:", error)
            }
        },
        betValue(value) {
            if (value === 0 && !this.closedByTimer) {
                setTimeout(() => {
                    if (this.placeBetLoading) {
                        this.$store.commit("placeBet/set_closed_by_timer", true)
                        this.destroyPopover()
                    }
                }, 250)
            }
        }
    },
    async created() {
        if (this.closedByTimer) {
            this.placeBetLoading = true
            this.$store.commit("placeBet/set_loading", true)
            this.$store.dispatch("betLoading/begin", {
                seconds: 0,
                bettingType: "default"
            })
        }
        if (this.$auth.loggedIn) {
            if (!this.userConfig) {
                await this.$store.dispatch("settings/getUserConfig")
            }
        }
        await this.initiatePopover()
        if (this.stakeValue) {
            this.stake = this.stakeValue
        }
    },
    updated() {
        this.sendPopoverHeight()
    },
    // beforeDestroy() {
    //   this.cancelBtn()
    // },
    methods: {
        async initiatePopover() {
            this.odds = cloneDeep(this.$store.state.placeBet.odds)
            if (this.bettingType === "lineLadder") {
                this.odds = ceil(this.odds)
            }
            this.position = this.$store.state.placeBet.oddsIndex
            this.type = cloneDeep(this.$store.state.placeBet.type)
            this.$store.commit("betBooks/reset_newData")
            this.$store.commit("betBooks/reset_newPremiumData")
            this.$store.commit("betBooks/reset_newbookmakerData")
            // if (this.bettingType === 'lineLadder') {
            //   const oddsLine = cloneDeep(this.$store.state.placeBet.odds)
            //   this.odds = ceil(oddsLine)
            // }
            if (this.$auth.loggedIn) {
                this.$store.dispatch("user/checkvpn")

                if (
                    this.bettingType === "bookmaker" ||
                    this.bettingType === "multiHorse" ||
                    this.bettingType === "lineLadder" ||
                    this.bettingType === "premiumsports" ||
                    this.bettingType === "artemisBookmaker" ||
                    this.bettingType === "artemisFancy"
                ) {
                    this.oddsRules = [
                        (v) => !!v || "Odds is required",
                        (v) => parseFloat(v) >= 0 || "Min. 0.1"
                    ]
                }
                let minBetfairId

                if (this.bettingType === "fancy") {
                    minBetfairId = this.bettingRunner.betfairId
                }
                if (
                    this.bettingType === "artemisBookmaker" ||
                    this.bettingType === "artemisFancy"
                ) {
                    minBetfairId = this.bettingRunner.marketId
                }
                let minMaxData = {}
                if (
                    this.bettingType !== "premiumsports" &&
                    this.bettingType !== "artemisBookmaker" &&
                    this.bettingType !== "artemisFancy"
                ) {
                    minMaxData = {
                        game: upperFirst(
                            this.bettingMarket.eventType.name ||
                                this.$route.params.category
                        ),
                        loading: true,
                        oddsSelected: this.odds,
                        position: this.position,
                        selectionId: this.bettingRunner.id,
                        type: this.type
                        // marketId: minBetfairId
                        // marketId: this.bettingMarket?.betfairId
                        //   ? this.bettingMarket?.betfairId
                        //   : minBetfairId
                    }
                    if (minBetfairId) {
                        minMaxData.marketId = minBetfairId
                    } else if (
                        this.bettingMarket &&
                        this.bettingMarket.betfairId
                    ) {
                        minMaxData.marketId = this.bettingMarket.betfairId
                    }
                }
                minMaxData.bettingType = this.bettingType
                minMaxData.name = this.bettingMarket?.name
                const maxAmtUnlimited = 1000000000000000

                if (
                    this.bettingMarket &&
                    (this.minMaxMarket === undefined ||
                        this.minMaxMarket === "No Data Found" ||
                        this.minMaxMarket === "Network Error") &&
                    this.bettingType !== "premiumsports" &&
                    this.bettingType !== "artemisBookmaker" &&
                    this.bettingType !== "artemisFancy"
                ) {
                    for (let count = 0; count < this.endPoint; count++) {
                        await this.$store.dispatch(
                            "matchInside/getMinMaxMarket",
                            minMaxData
                        )
                        if (
                            this.bettingMarket &&
                            (this.minMaxMarket === "No Data Found" ||
                                this.minMaxMarket === "Network Error")
                        ) {
                            this.minBet = 1
                            this.maxBetAmt = maxAmtUnlimited
                            this.maxBetShow = false
                        } else if (
                            this.bettingMarket &&
                            this.minMaxMarket !== "No Data Found" &&
                            this.minMaxMarket !== "Network Error"
                        ) {
                            if (
                                (this.minMaxMarket &&
                                    this.minMaxMarket?.minBet === 0) ||
                                (this.minMaxMarket &&
                                    !this.minMaxMarket?.minBet)
                            ) {
                                this.minBet = 1
                            } else {
                                this.minBet = this.minMaxMarket?.minBet
                            }

                            if (
                                this.minMaxMarket?.maxWinning &&
                                this.minMaxMarket?.maxWinning === 0
                            ) {
                                this.maxMarketAmount = maxAmtUnlimited
                                this.maxMarketAmountShow = false
                            } else {
                                this.maxMarketAmount =
                                    this.minMaxMarket?.maxWinning
                            }
                            if (
                                !this.minMaxMarket?.maxBet ||
                                (this.minMaxMarket &&
                                    this.minMaxMarket?.maxBet &&
                                    this.minMaxMarket?.maxBet === 0)
                            ) {
                                this.maxBetShow = false
                                this.maxBetAmt = maxAmtUnlimited
                                this.placeholderMinMax = "Min. " + this.minBet
                            } else {
                                this.maxBetShow = true
                                this.maxBetAmt = this.minMaxMarket?.maxBet
                                this.placeholderMinMax =
                                    "Min. " +
                                    this.minBet +
                                    " Max. " +
                                    this.maxBetAmt
                            }
                        }
                    }
                } else if (
                    this.bettingType !== "premiumsports" &&
                    this.bettingType !== "artemisBookmaker" &&
                    this.bettingType !== "artemisFancy" &&
                    this.bettingMarket &&
                    this.minMaxMarket
                ) {
                    for (let count = 0; count < this.endPoint; count++) {
                        await this.$store.dispatch(
                            "matchInside/getMinMaxMarket",
                            minMaxData
                        )
                        if (
                            this.bettingMarket &&
                            (this.minMaxMarket === "No Data Found" ||
                                this.minMaxMarket === "Network Error")
                        ) {
                            this.minBet = 1
                            this.maxBetAmt = maxAmtUnlimited
                            this.maxBetShow = false
                        } else if (
                            this.bettingMarket &&
                            this.minMaxMarket !== "No Data Found" &&
                            this.minMaxMarket !== "Network Error"
                        ) {
                            if (
                                (this.minMaxMarket &&
                                    this.minMaxMarket?.minBet === 0) ||
                                (this.minMaxMarket &&
                                    !this.minMaxMarket?.minBet)
                            ) {
                                this.minBet = 1
                            } else {
                                this.minBet = this.minMaxMarket?.minBet
                            }

                            if (
                                this.minMaxMarket?.maxWinning &&
                                this.minMaxMarket?.maxWinning === 0
                            ) {
                                this.maxMarketAmount = maxAmtUnlimited
                                this.maxMarketAmountShow = false
                            } else {
                                this.maxMarketAmount =
                                    this.minMaxMarket?.maxWinning
                            }
                            if (
                                !this.minMaxMarket?.maxBet ||
                                (this.minMaxMarket &&
                                    this.minMaxMarket?.maxBet &&
                                    this.minMaxMarket?.maxBet === 0)
                            ) {
                                this.maxBetShow = false
                                this.maxBetAmt = maxAmtUnlimited
                                this.placeholderMinMax = "Min. " + this.minBet
                            } else {
                                this.maxBetShow = true
                                this.maxBetAmt = this.minMaxMarket?.maxBet
                                this.placeholderMinMax =
                                    "Min. " +
                                    this.minBet +
                                    " Max. " +
                                    this.maxBetAmt
                            }
                        }
                    }
                } else if (this.bettingType === "premiumsports") {
                    minMaxData = {
                        marketId: this.bettingMarket._id,
                        loading: true
                    }
                    await this.$store.dispatch(
                        "matchInside/getMinMaxMarketPremium",
                        minMaxData
                    )
                    if (
                        (this.minMaxMarketPremium &&
                            this.minMaxMarketPremium.minBetAmt === 0) ||
                        !this.minMaxMarketPremium.minBetAmt
                    ) {
                        this.minBet = 1
                    } else {
                        this.minBet = this.minMaxMarketPremium.minBetAmt
                    }
                    if (
                        this.minMaxMarketPremium.maxWinnings &&
                        this.minMaxMarketPremium.maxWinnings === 0
                    ) {
                        this.maxMarketAmount = maxAmtUnlimited
                        this.maxMarketAmountShow = false
                    } else {
                        this.maxMarketAmount =
                            this.minMaxMarketPremium.maxWinnings
                    }
                    if (
                        !this.minMaxMarketPremium.maxBetAmt ||
                        (this.minMaxMarketPremium &&
                            this.minMaxMarketPremium.maxBetAmt &&
                            this.minMaxMarketPremium.maxBetAmt === 0)
                    ) {
                        this.maxBetShow = false
                        this.maxBetAmt = maxAmtUnlimited
                        this.placeholderMinMax = "Min. " + this.minBet
                    } else {
                        this.maxBetShow = true
                        this.maxBetAmt = this.minMaxMarketPremium.maxBetAmt
                        this.placeholderMinMax =
                            "Min. " + this.minBet + " Max. " + this.maxBetAmt
                    }
                } else if (
                    this.bettingType === "artemisBookmaker" ||
                    this.bettingType === "artemisFancy"
                ) {
                    if (this.bettingType === "artemisBookmaker") {
                        minMaxData = {
                            marketId: this.bettingMarket._id,
                            oddsSelected: this.odds,
                            type: this.type,
                            loading: true
                        }
                        await this.$store.dispatch(
                            "matchInside/getMinMaxMarketBookmaker",
                            minMaxData
                        )
                    } else if (this.bettingType === "artemisFancy") {
                        minMaxData = {
                            marketId: this.bettingRunner._id,
                            oddsSelected: this.odds,
                            type: this.type,
                            loading: true
                        }
                        await this.$store.dispatch(
                            "matchInside/getMinMaxFancyMarket",
                            minMaxData
                        )
                    }

                    if (
                        (this.minMaxMarketBookmaker &&
                            this.minMaxMarketBookmaker?.maxBet === 0) ||
                        !this.minMaxMarketBookmaker?.maxBet
                    ) {
                        this.minBet = 1
                    } else {
                        this.minBet = this.minMaxMarketBookmaker?.minBet
                    }
                    if (
                        this.minMaxMarketBookmaker?.maxWinning &&
                        this.minMaxMarketBookmaker?.maxWinning === 0
                    ) {
                        this.maxMarketAmount = maxAmtUnlimited
                        this.maxMarketAmountShow = false
                    } else {
                        this.maxMarketAmount =
                            this.minMaxMarketBookmaker?.maxWinning
                    }
                    if (
                        !this.minMaxMarketBookmaker?.maxBet ||
                        (this.minMaxMarketBookmaker &&
                            this.minMaxMarketBookmaker?.maxBet &&
                            this.minMaxMarketBookmaker?.maxBet === 0)
                    ) {
                        this.maxBetShow = false
                        this.maxBetAmt = maxAmtUnlimited
                        this.placeholderMinMax = "Min. " + this.minBet
                    } else {
                        this.maxBetShow = true
                        this.maxBetAmt = this.minMaxMarketBookmaker?.maxBet
                        this.placeholderMinMax =
                            "Min. " + this.minBet + " Max. " + this.maxBetAmt
                    }
                } else if (
                    (this.bettingMarket &&
                        this.minMaxMarket &&
                        this.minMaxMarket !== "No Data Found" &&
                        this.minMaxMarket !== "Network Error") ||
                    (this.bettingType !== "premiumsports" &&
                        this.bettingType !== "artemisBookmaker" &&
                        this.bettingType !== "artemisFancy")
                ) {
                    if (
                        (this.minMaxMarket &&
                            this.minMaxMarket?.minBet &&
                            this.minMaxMarket?.minBet === 0) ||
                        (this.minMaxMarket && !this.minMaxMarket?.minBet) ||
                        (!this.minMaxMarket && !this.minMaxMarket?.minBet)
                    ) {
                        this.minBet = 1
                    } else {
                        this.minBet = this.minMaxMarket?.minBet
                    }

                    if (
                        this.minMaxMarket?.maxWinning &&
                        this.minMaxMarket?.maxWinning === 0
                    ) {
                        this.maxMarketAmount = maxAmtUnlimited
                        this.maxMarketAmountShow = false
                    } else {
                        this.maxMarketAmount = this.minMaxMarket?.maxWinning
                    }
                    if (
                        !this.minMaxMarket?.maxBet ||
                        (this.minMaxMarket &&
                            this.minMaxMarket?.maxBet &&
                            this.minMaxMarket?.maxBet === 0)
                    ) {
                        this.maxBetShow = false
                        this.maxBetAmt = maxAmtUnlimited
                        this.placeholderMinMax = "Min. " + this.minBet
                    } else {
                        this.maxBetShow = true
                        this.maxBetAmt = this.minMaxMarket?.maxBet
                        this.placeholderMinMax =
                            "Min. " + this.minBet + " Max. " + this.maxBetAmt
                    }
                } else {
                    this.$store.commit("snackbar/open", {
                        text: this.minMaxMarket,
                        color: "error"
                    })
                }
            }
            this.$nextTick(() => {
                // Check for mobile screen (xsOnly)
                const isMobile = this.$breakpoint.xsOnly

                // Get target element from ref
                const target =
                    this.$refs[this.randomId]?.$el || this.$refs[this.randomId]

                // Dynamically calculate the height of the header (example with '.v-app-bar')
                const headerHeight =
                    document.querySelector(".v-app-bar")?.offsetHeight || 0

                const commHeight =
                    this.$route.name === "sportsbook-category" ? 40 : 10
                console.log(this.$route.name)
                if (isMobile && target) {
                    // Fallback to $vuetify.goTo if we want smooth scrolling with offset
                    this.$vuetify.goTo(target, {
                        duration: 10, // Set a reasonable scroll duration
                        easing: "easeInOutCubic",
                        offset: headerHeight + commHeight // Adjust based on dynamic header height
                    })

                    // Optionally, using scrollIntoView for better control:
                    if (target.scrollIntoView) {
                        console.log("ssss", headerHeight)
                        target.scrollIntoView({
                            behavior: "smooth", // Smooth scrolling
                            block: "start", // Scroll to the start of the element
                            inline: "nearest"
                        })
                    }
                }

                // Focus the stake input after scrolling
                const stakeInput = this.$refs.stake?.$el?.querySelector("input")
                if (stakeInput) {
                    setTimeout(() => {
                        stakeInput.focus() // Ensure focusing after scroll
                    }, 50)
                }
            })
        },
        cancelBtn() {
            this.$store.commit("placeBet/reset_popover")
            this.$store.commit("betBooks/reset_newData")
            this.$store.commit("betBooks/reset_newPremiumData")
            this.$store.commit("betBooks/reset_newbookmakerData")
            const isDrawerOpen = localStorage.getItem("bottomBar")
                ? JSON.parse(localStorage.getItem("bottomBar"))
                : true
            this.$store.commit(
                "notificationMarquee/set_isBottomDrawerOpen",
                isDrawerOpen
            )
            this.stake = ""
            this.$emit("getPopoverHeight", 0)
        },
        stakesAdd(value) {
            this.$nextTick(this.$refs.stake.focus)
            this.$refs?.stake?.$el?.focus()
            if (isNaN(parseFloat(this.stake))) {
                this.stake = 0
            }
            this.stake = parseFloat(this.stake) + parseFloat(value)
        },
        oddsStepper(event) {
            if (this.bettingType === "lineLadder") {
                if (event === "up") {
                    this.odds = this.odds + 1
                } else if (event === "down") {
                    this.odds = this.odds - 1
                }
            } else {
                this.odds = this.incOrDec(this.odds, event)
            }
        },
        calculateWinnings() {
            if (this.stake > 0 && this.odds > 0) {
                let odds = this.odds
                if (this.bettingType === "lineLadder") {
                    odds = this.lineSession
                }
                if (
                    this.bettingType === "bookmaker" ||
                    this.bettingType === "fancy" ||
                    this.bettingType === "artemisBookmaker" ||
                    this.bettingType === "artemisFancy" ||
                    this.bettingType === "multiHorse"
                ) {
                    if (this.bettingMarket.placeBetCalcType !== 0) {
                        if (this.bettingMarket.placeBetCalcType === 2) {
                            odds = odds + 1
                        } else {
                            odds = odds / 100 + 1
                        }
                    }
                }
                const m = multiply(parseFloat(odds), parseFloat(this.stake))
                const s = subtract(m, parseFloat(this.stake))
                this.winning = round(s, 2)
                if (
                    this.bettingType === "default" ||
                    this.bettingType === "lottery" ||
                    this.bettingType === "threeEt" ||
                    this.bettingType === "premiumsports" ||
                    this.bettingType === "bookmaker" ||
                    this.bettingType === "artemisBookmaker"
                ) {
                    this.newBook(this.winning)
                }
            }
        },
        newBook(winning) {
            let stake
            if (this.type === "back") {
                stake = -parseFloat(this.stake)
            } else {
                winning = -winning
                stake = parseFloat(this.stake)
            }
            const horse = map(this.bettingAllRunners, (r) => {
                if (
                    r &&
                    r.betfairId &&
                    this.bettingRunner &&
                    this.bettingRunner.betfairId &&
                    r.betfairId === this.bettingRunner.betfairId &&
                    this.bettingType !== "premiumsports" &&
                    this.bettingType !== "artemisBookmaker" &&
                    this.bettingType !== "artemisFancy"
                ) {
                    return {
                        horse: r.betfairId,
                        amount: winning
                    }
                } else if (
                    r &&
                    r.id &&
                    this.bettingRunner &&
                    this.bettingRunner.id &&
                    r.id === this.bettingRunner.id &&
                    this.bettingType === "premiumsports"
                ) {
                    return {
                        // id: r.id,
                        [r.id]: winning
                    }
                } else if (
                    r &&
                    r.id &&
                    this.bettingRunner &&
                    this.bettingRunner.id &&
                    r.id === this.bettingRunner.id &&
                    this.bettingType === "artemisBookmaker"
                ) {
                    return {
                        _id: r.id,
                        amount: winning
                    }
                } else if (
                    r &&
                    r.id &&
                    this.bettingRunner &&
                    this.bettingRunner.id &&
                    r.id !== this.bettingRunner.id &&
                    this.bettingType === "artemisBookmaker"
                ) {
                    return {
                        _id: r.id,
                        amount: stake
                    }
                } else {
                    return {
                        horse: r.betfairId,
                        amount: stake
                    }
                }
            })
            let output = [
                {
                    marketId: this.bettingMarket.betfairId,
                    horse
                }
            ]
            if (this.bettingType === "premiumsports") {
                output = [
                    {
                        marketUniqueId: this.bettingMarket._id,
                        book: horse
                    }
                ]
            }
            if (this.bettingType === "artemisBookmaker") {
                output = [
                    {
                        _id: this.bettingMarket.marketId,
                        book: horse
                    }
                ]
                if (this.bettingMarket.marketType === "MultiBet") {
                    output[0].book = [
                        ...output[0].book,
                        {
                            _id: multibetlayBookHorseId,
                            amount: -parseFloat(this.stake)
                        }
                    ]
                }
            }
            setTimeout(() => {
                if (
                    this.$refs.betForm &&
                    this.$refs.betForm.validate() &&
                    this.bettingType !== "premiumsports" &&
                    this.bettingType !== "artemisBookmaker" &&
                    this.bettingType !== "artemisFancy"
                ) {
                    this.$store.commit("betBooks/set_newData", output)
                    this.$store.commit("betBooks/reset_newPremiumData")
                    this.$store.commit("betBooks/reset_newbookmakerData")
                } else if (
                    this.$refs.betForm &&
                    this.$refs.betForm.validate() &&
                    this.bettingType === "premiumsports"
                ) {
                    this.$store.commit("betBooks/set_newPremiumData", output)
                    this.$store.commit("betBooks/reset_newData")
                    this.$store.commit("betBooks/reset_newbookmakerData")
                } else if (
                    this.$refs.betForm &&
                    this.$refs.betForm.validate() &&
                    this.bettingType === "artemisBookmaker"
                ) {
                    this.$store.commit("betBooks/set_newbookmakerData", output)
                    this.$store.commit("betBooks/reset_newData")
                    this.$store.commit("betBooks/reset_newPremiumData")
                } else {
                    this.$store.commit("betBooks/reset_newData")
                    this.$store.commit("betBooks/reset_newPremiumData")
                    this.$store.commit("betBooks/reset_newbookmakerData")
                }
            }, 100)
        },
        async placeBet(status) {
            if (this.isTiedMatch()) {
                this.$store.commit("snackbar/open", {
                    text: "Bets can only be placed based on current odds",
                    color: "error"
                })
                return ""
            }
            if (this.$refs.betForm && this.$refs.betForm.validate()) {
                this.placeBetLoading = true

                if (this.loading) {
                    this.$store.commit("snackbar/open", {
                        text: "Please wait! Processing previous bet...",
                        color: "error"
                    })
                    return ""
                }
                if (
                    this.userConfig.confirmStatus &&
                    status !== "betConfirmed"
                ) {
                    this.placeBetLoading = false
                    this.$store.commit("confirmBet/open")
                    return ""
                }
                try {
                    // let watingSeconds
                    const setBettingType = this.bettingType
                    // if (this.bettingType === 'fancy') {
                    //   watingSeconds = this.bettingRunner.betDelay || 1
                    // } else if (this.bettingType === 'bookmaker') {
                    //   watingSeconds = this.bettingMarket.betDelay
                    // } else if (this.bettingType === 'lineLadder') {
                    //   watingSeconds = this.bettingMarket.betDelay + 1
                    // } else {
                    const watingSeconds = this.bettingMarket?.betDelay || 0
                    // }
                    if (
                        this.bettingType === "artemisBookmaker" ||
                        this.bettingType === "artemisFancy"
                    ) {
                        // this.$store.dispatch('betLoading/begin', {
                        //   seconds: this.betDelayforBookmakerFancy,
                        //   bettingType: setBettingType
                        // })
                        // setTimeout(() => {
                        //   this.apiPlaceBetForPremiumSports()
                        // }, watingSeconds * 1000)
                        await this.$store.dispatch("placeBet/execute", {
                            market: this.bettingMarket,
                            runner: this.bettingRunner,
                            odds: this.odds,
                            position: this.position,
                            runs: this.runs,
                            stake: Number(this.stake),
                            type: this.type,
                            winning: this.winning
                        })
                    } else if (this.bettingType !== "premiumsports") {
                        if (watingSeconds > 0) {
                            this.$store.dispatch("betLoading/begin", {
                                seconds: watingSeconds,
                                bettingType: setBettingType
                            })
                        }
                        await this.$store.dispatch("placeBet/execute", {
                            market: this.bettingMarket,
                            runner: this.bettingRunner,
                            odds: this.odds,
                            position: this.position,
                            runs: this.runs,
                            stake: Number(this.stake),
                            type: this.type,
                            winning: this.winning
                        })
                    } else {
                        const dataLoading = setTimeout(() => {
                            this.$store.commit("snackbar/open", {
                                text: "Error while placing bet!",
                                color: "error"
                            })
                            this.$store.commit("placeBet/set_loading", false)
                        }, 16000)
                        await this.$store
                            .dispatch("placeBet/execute", {
                                market: this.bettingMarket,
                                runner: this.bettingRunner,
                                odds: this.odds,
                                position: this.position,
                                runs: this.runs,
                                stake: Number(this.stake),
                                type: this.type,
                                winning: this.winning
                            })
                            .then(() => {
                                clearTimeout(dataLoading)
                            })
                    }

                    const { error, warning, success } =
                        this.$store.state.placeBet
                    if (
                        this.bettingType !== "artemisBookmaker" &&
                        this.bettingType !== "artemisFancy"
                    ) {
                        this.placeBetLoading = this.loading

                        if (this.bettingType !== "premiumsports") {
                            this.$store.dispatch("betLoading/close")
                        }

                        if (error) {
                            this.$store.commit("snackbar/open", {
                                text: error,
                                color: "error"
                            })

                            if (error === "Access Denied") {
                                this.$store.dispatch("user/logout")
                            }
                        } else if (warning) {
                            this.$store.commit("snackbar/open", {
                                text: warning.message,
                                color: "warning"
                            })
                        } else if (
                            success?.status === "UNMATCHED" &&
                            success?.message
                        ) {
                            if (
                                this.bettingType === "threeEt" ||
                                this.bettingType === "lineLadder"
                            ) {
                                console.error(success.message)
                            } else {
                                this.$store.commit("snackbar/open", {
                                    text: success.message,
                                    color: "error"
                                })
                            }
                        } else if (
                            success?.status !== "UNMATCHED" &&
                            success?.message
                        ) {
                            this.$store.commit("snackbar/open", {
                                text: success.message,
                                color: "success"
                            })
                        } else {
                            this.$store.commit("snackbar/open", {
                                text: success,
                                color: "success"
                            })
                        }

                        // this.cancelBtn()
                        if (
                            this.$auth.loggedIn &&
                            this.bettingType === "premiumsports"
                        ) {
                            this.cancelBtn()
                            await this.$store.dispatch(
                                "openBets/getMyCurrentPremiumRawBet"
                            )
                            if (
                                this.$route.name === "sportsbook" ||
                                this.$route.name === "sportsbook-category"
                            ) {
                                await this.$store.dispatch(
                                    "betBooks/getAllPremium",
                                    {
                                        refresh: this.refresh
                                    }
                                )
                            }
                            this.placeBetLoading = this.loading
                        }
                    } else if (error) {
                        this.cancelBtn()
                        this.placeBetLoading = this.loading
                        // setTimeout(() => {
                        this.$store.commit("snackbar/open", {
                            text: error,
                            color: "error"
                        })
                        if (error === "Access Denied") {
                            this.$store.dispatch("user/logout")
                        }
                        // this.$store.dispatch('betLoading/close')
                        // this.placeBetLoading = this.loading
                        // this.cancelBtn()
                        // }, this.betDelayforBookmakerFancy * 1000)
                    } else if (warning) {
                        this.cancelBtn()
                        this.placeBetLoading = this.loading
                        this.$store.commit("snackbar/open", {
                            text: warning?.message,
                            color: "warning"
                        })
                    }
                    this.$store.commit("placeBet/set_closed_by_timer", false)
                } catch (error) {
                    console.log(error)
                    this.destroyPopover()
                    this.$store.commit("placeBet/set_closed_by_timer", false)
                } finally {
                    this.destroyPopover()
                    this.$store.commit("placeBet/set_closed_by_timer", false)
                }
            }
        },
        onlyNumber($event) {
            const keyCode = $event.keyCode ? $event.keyCode : $event.which
            if (
                (keyCode < 48 || keyCode > 57) &&
                keyCode !== 46 &&
                keyCode !== 13
            ) {
                $event.preventDefault()
            }
        },
        oddsBlur() {
            const value = this.odds
            if (this.bettingType !== "lineLadder") {
                if (value >= 1.01 && value < 2) {
                    this.odds = this.incOrDecValidation(value, 0.01)
                } else if (value >= 2 && value < 3) {
                    this.odds = this.incOrDecValidation(value, 0.02)
                } else if (value >= 3 && value < 4) {
                    this.odds = this.incOrDecValidation(value, 0.05)
                } else if (value >= 4 && value < 6) {
                    this.odds = this.incOrDecValidation(value, 0.1)
                } else if (value >= 6 && value < 10) {
                    this.odds = this.incOrDecValidation(value, 0.2)
                } else if (value >= 10 && value < 20) {
                    this.odds = this.incOrDecValidation(value, 0.5)
                } else if (value >= 20 && value < 30) {
                    this.odds = this.incOrDecValidation(value, 1)
                } else if (value >= 30 && value < 50) {
                    this.odds = this.incOrDecValidation(value, 2)
                } else if (value >= 50 && value < 100) {
                    this.odds = this.incOrDecValidation(value, 5)
                } else if (value >= 100 && value < 1000) {
                    this.odds = this.incOrDecValidation(value, 10)
                }
            }
        },
        async setFancyLimit(maxAmtUnlimited) {
            // if(this.bettingType === 'fancy'){}
            if (
                this.$route.name ===
                    ("sportsbook-category-subCategory-id" ||
                        this.$route.name ===
                            "sportsbook-category-subCategory-id-betradar") &&
                !this.configLimits
            ) {
                let _accessToken
                if (this.$auth.loggedIn) {
                    _accessToken = this.$auth.getToken("customLocal")
                }
                await this.$store.dispatch("matchInside/getConfigMaxLimits", {
                    game: upperFirst(this.$route.params.category),
                    _accessToken,
                    loading: false
                })
            }

            const { maxLimitsType = "Minor" } = this.bettingRunner

            let maxRate = 1
            if (
                this.$auth.loggedIn &&
                this.$auth.user.currencyType === "POINT@1"
            ) {
                maxRate = 100
            }
            const maxBetFromLimit =
                this.configLimits["maxBetFancy" + maxLimitsType] / maxRate
            const maxMarketAmountFromLimit =
                this.configLimits["maxMarketAmountFancy" + maxLimitsType] /
                maxRate

            this.maxBetAmt = 0
            // MIN BET
            if (this.bettingMarket.minBet === 0) {
                this.minBet = 1
            } else {
                this.minBet = this.bettingMarket.minBet
            }

            // MAX BET
            if (this.bettingMarket.maxBetFancy === 0 && maxBetFromLimit === 0) {
                this.maxBetShow = false
                this.maxBetAmt = maxAmtUnlimited
                this.placeholderMinMax = "Min " + this.minBet
            } else {
                this.maxBetShow = true

                this.maxBetAmt = this.getMinimum(
                    maxBetFromLimit,
                    this.bettingMarket.maxBetFancy
                )
                this.placeholderMinMax =
                    "Min. " + this.minBet + " Max. " + this.maxBetAmt
            }

            // MAX MARKET
            if (
                this.bettingMarket.maxMarketAmountFancy === 0 &&
                maxMarketAmountFromLimit === 0
            ) {
                this.maxMarketAmount = maxAmtUnlimited
                this.maxMarketAmountShow = false
            } else {
                this.maxMarketAmount = this.getMinimum(
                    maxMarketAmountFromLimit,
                    this.bettingMarket.maxMarketAmountFancy
                )

                this.maxMarketAmountShow = true
            }
        },
        getMinimum(a, b) {
            let output = [a, b]
            output = compact(output)
            return min(output)
        },
        openCheck() {
            if (!this.$auth.loggedIn) {
                return false
            }
            if (
                this.$auth.loggedIn &&
                this.userConfig &&
                this.userConfig.oneClickStatus &&
                (this.bettingType === "default" ||
                    this.bettingType === "lineLadder" ||
                    this.bettingType === "premiumsports" ||
                    this.bettingType === "artemisBookmaker" ||
                    this.bettingType === "artemisFancy") &&
                !this.isCashOut
            ) {
                this.placeBetLoading = this.loading
                return true
            } else if (
                this.checkId === this.bettingRunner.betfairId ||
                this.checkId === this.bettingRunner.id ||
                this.checkId === this.bettingRunner.marketId ||
                this.checkId === this.bettingMarket.marketId
            ) {
                return true
            } else {
                return false
            }
        },
        isTiedMatch() {
            if (
                this.bettingMarket &&
                this.bettingMarket.name &&
                this.bettingMarket.name.toLowerCase() === "tied match" &&
                this.cloneType &&
                ((this.cloneType === "back" && this.odds > this.cloneOdds) ||
                    (this.cloneType === "lay" && this.odds < this.cloneOdds))
            ) {
                return true
            }
            return false
        },
        destroyPopover() {
            this.cancelBtn()
            this.placeBetLoading = false
            this.$store.commit("placeBet/set_loading", false)
            this.$store.dispatch("betLoading/close")
            this.$emit("getPopoverHeight", 0)
        },
        sendPopoverHeight() {
            const betPopoverRef =
                this.$refs[this.randomId]?.$el || this.$refs[this.randomId]

            this.$emit("getPopoverHeight", betPopoverRef.offsetHeight)
        }
    }
}
</script>
<style lang="scss" scoped>
$primary: var(--v-primary-base);

.all-radius {
    border-radius: 1rem !important;
}

.no-radius {
    border-radius: 0 !important;
}

.top-radius {
    border-radius: 0 0 1rem 1rem !important;
}

.cancelbtn {
    border-color: $primary;
    color: $primary;
}

.info-text {
    font-size: 10px;

    .info-icon {
        font-size: 13px;
    }
}
.whitespace-normal {
    white-space: normal;
}
</style>
